/**
 * Envío AP-3 · qué está seleccionado en el timeline y qué se le puede hacer.
 * Pura: la barra y el menú sobre el clip leen esto.
 */
const CLIP_KEYS = {
  video: 'videoClips', image: 'imageClips', v1: 'overlayV1Clips', v2: 'overlayV2Clips', audio: 'audioClips',
};
const KIND_LABEL = {
  video: 'Video', image: 'Imagen', v1: 'Superposición', v2: 'Superposición', audio: 'Audio',
  text: 'Texto', sticker: 'Sticker', transition: 'Transición',
};

export function fmtTime(s) {
  const t = Math.max(0, Number(s) || 0);
  const m = Math.floor(t / 60);
  const r = t - m * 60;
  return `${m}:${r < 10 ? '0' : ''}${r.toFixed(1).replace('.', ',')}`;
}

export function fmtSecs(s) {
  return `${(Number(s) || 0).toFixed(1).replace('.', ',')} s`;
}

/** null si no hay nada; si no, { kind, group, item, label, start, duration, can: {...} }. */
export function describeSelection(state) {
  const sel = state?.selectedClip;
  if (!sel?.id) return null;
  const { trackKind, id } = sel;
  if (CLIP_KEYS[trackKind]) {
    const clip = (state[CLIP_KEYS[trackKind]] || []).find((c) => c.id === id);
    if (!clip) return null;
    const t = state.playheadTime || 0;
    const inside = t > clip.start_time + 0.05 && t < clip.start_time + clip.duration - 0.05;
    const hasSound = trackKind === 'audio' || (clip.kind || 'video') === 'video';
    // AP-4 · «Editar imagen»: sólo imágenes (el video queda para el renderer).
    const isImage = trackKind !== 'audio' && (clip.kind || (trackKind === 'image' ? 'image' : 'video')) === 'image';
    return {
      group: 'clip', trackKind, id, item: clip,
      kindLabel: KIND_LABEL[trackKind],
      label: clip.label || KIND_LABEL[trackKind],
      start: clip.start_time, duration: clip.duration,
      thumb: clip.thumb_url || (clip.kind === 'image' ? clip.source_url : null),
      muted: !!clip.muted,
      edited: !!clip.edit?.original,
      can: { replace: true, cut: inside, duplicate: true, mute: hasSound, remove: true, editImage: isImage },
    };
  }
  if (trackKind === 'text' || trackKind === 'sticker') {
    const el = (state.elements || []).find((e) => e.element_id === id);
    if (!el) return null;
    return {
      group: 'element', trackKind, id, item: el,
      kindLabel: KIND_LABEL[trackKind],
      label: (trackKind === 'text' ? (el.content || '').split('\n')[0] : el.label) || KIND_LABEL[trackKind],
      start: el.start || 0, duration: el.duration || 0,
      thumb: trackKind === 'sticker' ? el.source_url || null : null,
      muted: false,
      can: { replace: false, cut: false, duplicate: true, mute: false, remove: true },
    };
  }
  if (trackKind === 'transition') {
    const tr = (state.videoTransitions || []).find((x) => x.id === id);
    if (!tr) return null;
    return {
      group: 'transition', trackKind, id, item: tr,
      kindLabel: KIND_LABEL.transition, label: 'Fundido a negro',
      start: null, duration: tr.duration, thumb: null, muted: false,
      can: { replace: false, cut: false, duplicate: false, mute: false, remove: true },
    };
  }
  return null;
}

/** Zoom para que todo el contenido entre en el ancho visible. */
export function fitZoom(totalDuration, viewportPx, basePxPerSec, min, max) {
  if (!(totalDuration > 0) || !(viewportPx > 0)) return 1;
  const z = (viewportPx * 0.94) / (totalDuration * basePxPerSec);
  return Math.max(min, Math.min(max, +z.toFixed(3)));
}
